export { default as CmsLargeAssetTopCenteredHero } from './CmsLargeAssetTopCenteredHero';
